var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RequisitionDialog',{attrs:{"onClose":_vm.handleClose,"requisitionType":"new_offer","requisitionId":_vm.requisitionId,"actionType":_vm.actionType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }